MemoService = ($http) ->
  
  updateMemo: (id, memo) ->
    $http.put "/api/score_cards/#{id}.json",
      memo: memo

MemoService.$inject = [
  '$http'
]

module.exports = MemoService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/round-detail/score-card-memo/memo-service.coffee